export function useKeyLongPressEvent({ el = document, handler, pressDuration = 2000 }) {
  const keyTimers = {};

  /**@param {KeyboardEvent} event */
  function keydownHandler(event) {
    const key = event.key;

    if (!keyTimers[key]) {
      keyTimers[key] = setTimeout(() => {
        handler(key);
      }, pressDuration);
    }
  }

  /**@param {KeyboardEvent} event */
  function keyupHandler(event) {
    const key = event.key;
    if (keyTimers[key]) {
      // 清除计时器
      clearTimeout(keyTimers[key]);
      delete keyTimers[key];
    }
  }

  el.addEventListener('keydown', keydownHandler);
  el.addEventListener('keyup', keyupHandler);

  return () => {
    el.removeEventListener('keydown', keydownHandler);
    el.removeEventListener('keyup', keyupHandler);
  };
}

/**
 * 点击元素外部触发事件的 Hook
 * @param {Object} options - 配置选项
 * @param {HTMLElement} options.el - 监听点击的元素
 * @param {Function} options.handler - 点击外部时触发的回调函数
 * @returns {Function} 清理函数，用于移除事件监听器
 */
export function useClickOutsideEvent({ el, handler }) {
  /**@param {MouseEvent} event */
  function clickHandler(event) {
    // 检查点击的元素是否在监听元素外部
    if (el && !el.contains(event.target)) {
      handler(event);
    }
  }

  document.addEventListener('click', clickHandler);

  return () => {
    document.removeEventListener('click', clickHandler);
  };
}

/**
 * 未移动过的点击事件
 * @param {HTMLElement} el
 * @param {() => {}} cb
 */
export function useNotMovedClick(el, cb) {
  let isDragging = false;
  let startX, startY, endX, endY;

  let time = 0;

  let isDbClick = false;

  let timer = null;

  const mousedownCb = event => {
    if (event.button === 2) return;

    isDbClick = false;

    if (performance.now() - time < 200) {
      isDbClick = true;
      clearTimeout(timer);
      return;
    }

    time = performance.now();

    isDragging = false;
    startX = event.clientX;
    startY = event.clientY;
  };

  const mouseupCb = event => {
    if (event.button === 2 || isDbClick) return;
    endX = event.clientX;
    endY = event.clientY;
    // 判断是否发生拖动
    if (
      Math.abs(startX - endX) < 5 &&
      Math.abs(startY - endY) < 5 &&
      performance.now() - time < 800
    ) {
      isDragging = false;
    } else {
      isDragging = true;
    }
    // 如果没有发生拖动，则触发 cb 函数
    if (!isDragging) {
      timer = setTimeout(() => {
        cb(event);
      }, 200);
    }
  };

  // 监听 mousedown 事件，记录鼠标点击的起始位置
  el.addEventListener('mousedown', mousedownCb);
  // 监听 mouseup 事件，记录鼠标释放的位置，并判断是否发生拖动
  el.addEventListener('mouseup', mouseupCb);

  return () => {
    clearTimeout(timer);
    el.removeEventListener('mousedown', mousedownCb);
    el.removeEventListener('mouseup', mouseupCb);
  };
}
